'use strict';

$(document).ready(function () {
    if ($('.photo-tile-container').length > 0) {
        $('.photo-tile-container').closest('.carousel-inner').addClass('justify-content-center');
    }
});
